import React from "react";
import {
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  TableContainer,
  Table as MuiTable,
} from "@mui/material";

export interface TableProps {
  data: (string | JSX.Element | React.ReactNode)[][];
  headers: string[];
}

export const Table = ({ headers, data }: TableProps) => {
  return (
    <TableContainer component={Paper}>
      <MuiTable>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((cells, index) => (
            <TableRow
              key={`table-row-${index}`}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              {cells.map((cell, i) => (
                <TableCell key={`table-cell-${index}-${i}`}>{cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
